import React, { Component } from "react";
import { Button, Form, FormGroup, Input, InputGroup, Label } from "reactstrap";
import { withRouter } from "react-router-dom";
import firebase from "../firebase";
import { GoogleAuth } from "../service/social-auth";
import { CheckUser, CreateUser } from "../api/dbSvc";
import * as routes from "../constants/routes";
import * as partner from "../constants/partner";
import { validate, placeholders, errorStrings } from "../helpers/validation";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { FaUser, FaLock } from "react-icons/fa";
import { Bar } from "./loader";
import "./login.css";

const INITIAL_STATE = {
  email: {
    value: "",
    valid: true,
    validationRules: {
      isEmail: true,
      minLength: 6
    },
    error: ""
  },
  password: {
    value: "",
    valid: true,
    validationRules: {
      isString: true,
      minLength: 6
    },
    error: ""
  },
  actionText: "Sign in",
  registerText: "Register now!",
  loading: false,
  origin: "",
  queryParams: {}
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  // componentDidMount = () => {
  //   const queryParams = this.props.queryParams;

  //   console.log(
  //     "login-check -> componentDidMount -> queryParams: ",
  //     queryParams
  //   );
  // };

  // componentDidUpdate = () => {
  //   const queryParams = this.props.queryParams;
  //   console.log(
  //     "login-check -> componentDidUpdate -> queryParams: ",
  //     queryParams
  //   );

  // };

  stopLoading = () => {
    this.setState({ loading: false });
  };

  startLoading = () => {
    this.setState({ loading: true });
  };

  signIn = (email, password) => {
    const auth = firebase.auth();
    const { history } = this.props;
    //console.log("signIn -> signing in...", email, " || ", password);
    auth
      .signInWithEmailAndPassword(email, password)
      .then(authUser => {
        //console.log("signIn -> uid", authUser.user.uid);
        this.setState({ ...INITIAL_STATE });
        this.stopLoading();
        history.push(routes.HOME);
      })
      .catch(error => {
        this.setState({ error });
        console.log("signIn -> error", error);
        this.stopLoading();
      });
  };

  //handle email/password auth
  onSubmit = async event => {
    event.preventDefault();
    this.startLoading();
    const { history } = this.props;
    const { email, password } = this.state;

    const auth = firebase.auth();
    if (this.state.actionText === "Sign up") {
      CreateUser(email.value, password.value, "javascript").then(response => {
        // console.log(
        //   "login.js -> createUser API output",
        //   JSON.stringify(response.output)
        // );
        console.log(
          "login.js -> onSubmit-> createUser API status",
          response.status
        );
        if (response.output) {
          localStorage.setItem("tkn", response.output.jwtToken);
        }
        this.signIn(email.value, password.value);
      });
    } else {
      //this.signIn(email.value, password.value);
      CheckUser(email.value).then(response => {
        if (response.output) {
          localStorage.setItem("tkn", response.output.jwtToken);
        }

        if (response.output && response.status === 200) {
          localStorage.setItem("tkn", response.output.jwtToken);
          // console.log(
          //   "login.js -> onSubmit -> user exists - response status: ",
          //   response.status
          // );
          this.signIn(email.value, password.value);
        }
      });
    }
  };

  //handle partner auth
  handlePartnerAuth = event => {
    event.preventDefault();
    this.startLoading();
    const { history } = this.props;
    const auth = firebase.auth();

    //remove setting queryParams in componentDidUpdate
    const queryParams = this.props.queryParams;
    console.log("handlePartnerAuth...");
    const origin = this.props.origin;
    if (origin === "partner" && Object.keys(queryParams).length !== 0) {
      // console.log("login.js -> handlePartnerAuth: ", queryParams.user_id);
      // console.log(
      //   "login.js -> handlePartnerAuth -> program_id: ",
      //   queryParams.program_id.toLowerCase()
      // );
      const bgUser = queryParams.user_id;
      const bgPswd = partner.BG_PSWD; //TBD - encode password

      const programID =
        typeof queryParams.program_id !== "undefined"
          ? queryParams.program_id.toLowerCase()
          : "javascript";

      CheckUser(bgUser).then(response => {
        // console.log(
        //   "login.js -> handlePartnerAuth -> checkUser jwt token",
        //   response.output
        // );
        if (response.output) {
          localStorage.setItem("tkn", response.output.jwtToken);
        }

        console.log("login.js -> checkUser API status", response.status);
        if (response.output && response.status === 200) {
          //user already exists
          this.signIn(bgUser, bgPswd);
        } else {
          CreateUser(bgUser, bgPswd, programID).then(response => {
            // console.log(
            //   "login.js -> createUser API output",
            //   JSON.stringify(response)
            // );
            if (response.output) {
              localStorage.setItem("tkn", response.output.jwtToken);
            }
            console.log(
              "login.js -> handlePartnerAuth -> createUser API status",
              response.status
            );
            this.signIn(bgUser, bgPswd);
          });
        }
      });
    }
  };

  handleChange = (key, event) => {
    event.preventDefault();

    let ctrl = { ...this.state[key] };
    ctrl.value = event.target.value;
    const isValid = validate(
      event.target.value,
      this.state[key].validationRules
    );
    ctrl.valid = isValid;
    //console.log(JSON.stringify(ctrl));
    let error = "";
    if (!isValid && ctrl.value !== "") {
      error = errorStrings[key];
    } else error = "";
    ctrl.error = error;
    this.setState({ [key]: ctrl });
  };

  handleRegister = () => {
    this.setState(prevState => ({
      actionText:
        prevState.actionText === "Sign in"
          ? "Sign up"
          : prevState.actionText === "Sign up"
          ? "Sign in"
          : prevState.actionText
    }));

    this.setState(
      prevState => ({
        registerText:
          prevState.registerText === "Register now!"
            ? "Sign in"
            : prevState.registerText === "Sign in"
            ? "Register now!"
            : prevState.registerText
      })
      // () => console.log("registerText: ", this.state.registerText)
    );
  };

  handleGoogleAuth = async () => {
    const { history } = this.props;
    this.startLoading();
    try {
      const { user, idToken, error } = (await GoogleAuth()) || "";

      if (user) {
        //check against users collection; if user already exists, overwrite
        const db = firebase.firestore();
        // const userRef = db.doc(`users/${user.uid}`);
        const userRef = db.doc(`users/${user.email}`);
        userRef
          .set({
            courses: [],
            email: user.email,
            partner: "",
            username: ""
          })
          .catch(error => {
            this.setState({ error });
            console.log("Login -> add new Google auth user failed");
            this.stopLoading();
          });

        this.stopLoading();
        history.push(routes.HOME);
      } else {
        console.log("Login -> GoogleAuth -> user not available ");
        this.stopLoading();
      }
    } catch (error) {
      console.log("Login -> error from GoogleAuth: ", error);
      this.stopLoading();
    }
  };

  render() {
    let email = { ...this.state.email };
    let password = { ...this.state.password };

    let loading = this.state.loading;
    const error = email.error;

    const isInvalid = email.valid === false;
    //console.log("Login -> origin: ", this.props.origin);

    const loginForm = (
      <div className="login-form">
        <Form
          className="form-username justify-content-center"
          onSubmit={this.onSubmit}
        >
          <Bar loading={loading} />
          <h5 className="text-center">
            {this.state.actionText} to start learning!
          </h5>
          <div className="text-center social-btn">
            <button
              className="btn btn-info btn-block"
              disabled={true}
              style={{ backgroundColor: "#4078c0" }}
            >
              <i>
                <FaGithub size={17} />
              </i>
              {this.state.actionText} with <b>Github</b>
            </button>

            <button
              className="btn btn-danger btn-block"
              onClick={this.handleGoogleAuth}
              style={{ backgroundColor: "#DB4437" }}
            >
              <i>
                <FaGoogle size={17} />
              </i>
              {this.state.actionText} with <b>Google</b>
            </button>
          </div>
          <div className="or-seperator">
            <i>or</i>
          </div>
          <FormGroup>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i>
                    <FaUser size={17} />
                  </i>
                </span>
              </div>

              <Input
                className="form-control"
                value={email.value}
                type="email"
                id="email"
                placeholder={placeholders["email"]}
                onChange={event => this.handleChange("email", event)}
              />
            </InputGroup>
            <p style={{ color: "#fff", fontSize: "9px" }}>{error}</p>
          </FormGroup>
          <FormGroup>
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i>
                    <FaLock size={17} />
                  </i>
                </span>
              </div>

              <Input
                className="form-control"
                value={password.value}
                type="password"
                id="password"
                placeholder={placeholders["password"]}
                onChange={event => this.handleChange("password", event)}
              />
            </InputGroup>
            <p style={{ color: "#fff", fontSize: "9px" }}>{error}</p>
          </FormGroup>
          <FormGroup>
            <button
              className="btn btn-success btn-block login-btn"
              disabled={isInvalid}
              type="submit"
              // disabled={isInvalid || !navigator.onLine}
            >
              {this.state.actionText}
            </button>
          </FormGroup>
          <div className="bottom-text-container">
            <Label className="pull-left checkbox-inline">
              <Input type="checkbox" /> Remember me
            </Label>
            <a href="#" className="pull-right text-success">
              Forgot Password?
            </a>
          </div>
        </Form>

        <div className="hint-text small" style={{ color: "#dfdbda" }}>
          {this.state.actionText === "Sign up"
            ? "Have an account? "
            : "Don't have an account? "}
          <a
            href="#"
            className="text-white register-action-text"
            // style={{ color: "#fffffd", fontWeight: "bold" }}
            onClick={this.handleRegister}
          >
            {this.state.registerText}
          </a>
        </div>
      </div>
    );

    const partnerForm = (
      <div className="login-check-form">
        <Form className="form-username justify-content-center">
          <Bar loading={loading} />
          <h5 className="text-center">Start learning!</h5>

          <div className="or-seperator">{/* <i>or</i> */}</div>

          <FormGroup>
            <Button
              // className="btn btn-success btn-block login-btn"

              className="login-btn"
              color="success"
              block
              onClick={this.handlePartnerAuth}
            >
              Access editor
            </Button>
          </FormGroup>
        </Form>
      </div>
    );

    //return <div className="login-container">{loginCheckForm}</div>;

    // uses context
    // return (
    //   <PartnerContext.Consumer>
    //     {origin =>
    //       origin === "home" ? (
    //         <div className="login-container">{loginForm}</div>
    //       ) : (
    //         <div className="login-container">{partnerForm}</div>
    //       )
    //     }
    //   </PartnerContext.Consumer>
    // );
    //uses props
    return (
      // <div>
      //   {this.props.origin === "home" ? (
      //     <div className="login-container">{loginForm}</div>
      //   ) : (
      //     <div className="login-container">{partnerForm}</div>
      //   )}
      // </div>
      <div>
        {this.props.origin === "partner" ? (
          <div className="login-container">{partnerForm}</div>
        ) : (
          <div className="login-container">{loginForm}</div>
        )}
      </div>
    );
  }
}

export default withRouter(Login);
